import { render, staticRenderFns } from "./taskSet.vue?vue&type=template&id=befe44dc&scoped=true&"
import script from "./taskSet.vue?vue&type=script&lang=js&"
export * from "./taskSet.vue?vue&type=script&lang=js&"
import style0 from "./taskSet.vue?vue&type=style&index=0&id=befe44dc&prod&lang=scss&scoped=true&"
import style1 from "./taskSet.vue?vue&type=style&index=1&id=befe44dc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "befe44dc",
  null
  
)

export default component.exports